import { getApiUrl } from "./config";
import { createAuthClient } from "better-auth/react";
import { organization, jwt, bearer } from "better-auth/plugins";
import { emailOTPClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: getApiUrl("/api/auth"),
  plugins: [organization(), jwt(), bearer(), emailOTPClient()],
  fetchOptions: {
    credentials: "include",
    onSuccess: (ctx) => {
      const data = ctx.data as any;
      const url = new URL(ctx.request.url);
      if (url.pathname?.includes("sign-out")) {
        localStorage.removeItem("better-auth.session_token");
        localStorage.removeItem("token");
        return;
      }

      const token =
        data?.token ||
        data?.session?.token ||
        ctx.response.headers.get("set-auth-jwt") ||
        ctx.response.headers.get("set-auth-token") ||
        ctx.response.headers.get("Authorization")?.replace("Bearer ", "");

      if (token) {
        localStorage.setItem("better-auth.session_token", token);
      }
    },
  },
});

// @ts-ignore
export const { signIn, signUp, useSession, forgetPassword, resetPassword } =
  authClient;

// Organization API methods for invitation management
// @ts-ignore - Better Auth generates these from the organization plugin
export const organizationClient = authClient.organization;

export const signInWithSocial = (provider: string) => {
  const callbackURL = window.location.origin + `/auth/callback/${provider}`;
  return authClient.signIn.social({
    provider: provider as any,
    callbackURL,
    errorCallbackURL: callbackURL,
  });
};